import React, { Component, memo } from "react"
import PubNubReact from "pubnub-react"

class PubNubController extends Component {
  constructor(props) {
    super(props)
    this.pubnub = new PubNubReact({
      // subscribeKey: "sub-c-85181450-16bf-11ea-95d3-4a09dafe54f0",
      subscribeKey:
        process.env.REACT_APP_ENV === "production"
          ? process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY
          : process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY_STAGING,
    })
    this.pubnub.init(this)
  }

  componentWillMount() {
    this.pubnub.subscribe({
      channels: [this.props.channelName],
      withPresence: true,
    })



    this.pubnub.getMessage(this.props.channelName, msg => {
      this.props.onAction(msg.message)
    })

  }

  componentWillUnmount() {
    this.pubnub.unsubscribe({
      channels: [this.props.channelName],
    })
  }

  render() {

    return <div />
  }
}
export default memo(PubNubController)
